import React from 'react';

function TableContent({ headers, varianceReport }) {
  const paddingMode = localStorage.getItem('paddingMode') || 'comfy';

  const renderCellValue = (row, header) => {
    const value = row[header.value];
    if (Array.isArray(value)) {
      return value.length ? [...new Set(value)].join(', ') : '-';
    }
    if (value === null || value === undefined || value === '') return '-';
    return value;
  };

  return (
    <tbody>
      {varianceReport?.length > 0 ? (
        varianceReport.map((row, rowIndex) => (
          <tr key={row.vehicle_tracking_number ?? rowIndex}>
            {headers.map((header, index) => (
              <td
                className={`table-data ${
                  paddingMode === 'compact'
                    ? 'compact-padding'
                    : 'comfortable-padding'
                }`}
                key={header.columnId}
              >
                <div className="div-flex-row div-align-center cg-5">
                  {index === 0 && (
                    <input type="checkbox" className="checkbox-grey" />
                  )}
                  <span>{renderCellValue(row, header)}</span>
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={headers.length || 1}>
            <div className="no-list-data-message border-bottom">
              <span className="text-sm">No Variance Report Data Found</span>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default TableContent;
